<script setup lang="ts">
import { type TextFieldProps, useTextField } from "@formwerk/core";

const props = defineProps<TextFieldProps>();
const { inputProps, labelProps, errorMessage, errorMessageProps, descriptionProps, isTouched } = useTextField(props);
</script>

<template>
  <div class="field">
    <label v-bind="labelProps">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <textarea v-bind="inputProps" />
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
    <div v-if="description" v-bind="descriptionProps" class="text-sm text-muted">
      {{ description }}
    </div>
  </div>
</template>
